import { Subscription } from 'rxjs';
import { Directive, OnDestroy } from '@angular/core';

@Directive({ standalone: false })
export abstract class CustomComponent implements OnDestroy {
  private subscriptions: Subscription[] = [];

  ngOnDestroy() {
    this.unsubscribeAll();
  }

  public addSubscriber(subscriber: Subscription) {
    this.subscriptions.push(subscriber);
    return subscriber;
  }

  public unsubscribeAll() {
    this.subscriptions.forEach((s) => {
      if (s) {
        s.unsubscribe();
      }
    });
  }
}
